import {
  type Language,
  type LanguageProficiencyLevel,
} from '#app/__generated__/api.js';
import {
  PROFESSIONAL_LANGUAGE_LABELS,
  PROFESSIONAL_LANGUAGE_PROFICIENCY_LABELS,
} from '#app/features/workPreferences/constants.js';

const formatLanguageString = (
  proficiency: LanguageProficiencyLevel,
  languages: Language[],
) => {
  if (proficiency === '%future added value') {
    return '';
  }

  if (languages.length <= 2) {
    return (
      PROFESSIONAL_LANGUAGE_PROFICIENCY_LABELS[proficiency] +
      ' in ' +
      languages
        .map((lang) =>
          lang === '%future added value'
            ? null
            : PROFESSIONAL_LANGUAGE_LABELS[lang],
        )
        .join(' and ')
    );
  }

  return (
    PROFESSIONAL_LANGUAGE_PROFICIENCY_LABELS[proficiency] +
    ' in ' +
    languages
      .map((lang) =>
        lang === '%future added value'
          ? null
          : PROFESSIONAL_LANGUAGE_LABELS[lang],
      )
      .join(', ')
      .replace(/, ([^,]*)$/, ', and $1')
  );
};

export const getReadableLanguagesString = (
  languages: ReadonlyArray<{
    name: Language;
    proficiency: LanguageProficiencyLevel;
  }>,
): string => {
  const proficiencyArray: {
    fluent: Language[];
    limited: Language[];
    professional: Language[];
  } = {
    fluent: [],
    limited: [],
    professional: [],
  };
  const languageProficiencies = languages.reduce(
    (sortedLanguages, language) => {
      if (language.name !== '%future added value') {
        switch (language.proficiency) {
          case 'FLUENT':
            sortedLanguages.fluent.push(language.name);
            return sortedLanguages;
          case 'LIMITED_WORKING':
            sortedLanguages.limited.push(language.name);
            return sortedLanguages;
          case 'PROFESSIONAL_WORKING':
            sortedLanguages.professional.push(language.name);
            return sortedLanguages;
          default:
            return sortedLanguages;
        }
      }

      return sortedLanguages;
    },
    proficiencyArray,
  );

  const languagesStrings: string[] = [];
  if (languageProficiencies.fluent.length) {
    languagesStrings.push(
      formatLanguageString('FLUENT', languageProficiencies.fluent),
    );
  }

  if (languageProficiencies.professional.length) {
    languagesStrings.push(
      formatLanguageString(
        'PROFESSIONAL_WORKING',
        languageProficiencies.professional,
      ),
    );
  }

  if (languageProficiencies.limited.length) {
    languagesStrings.push(
      formatLanguageString('LIMITED_WORKING', languageProficiencies.limited),
    );
  }

  return languagesStrings.join(' • ');
};
